var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMissedCallSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4 4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.341 1.111v2.667H4V0H.264v.667h2.593L0 3.511.484 4z",
    fill: "#fa0043"
  })));
}

export default SvgMissedCallSm;